import React from "react";
import Button from "components/atoms/Button";

const ActionButtons = ({ onApply, onExport, isExportVisible, isDisabled }) => (
  <div className="filter-condition">
    <Button
      variant="primary"
      size="normal"
      onClick={onApply}
      isDisabled={isDisabled}
    >
      Terapkan
    </Button>
    {isExportVisible && (
      <Button
        variant="secondary"
        size="normal"
        onClick={onExport}
        isDisabled={isDisabled}
      >
        Export Excel
      </Button>
    )}
  </div>
);

export default ActionButtons;
